
<div [class.tw-mt-0]="noSpaceTop" class="tw-my-3 tw-px-1">
    <div class="tw-flex tw-items-center tw-justify-between tw-cursor-pointer tw-mb-1 tw-px-2"
        (click)="toggle()">
        
        <div class="tw-flex tw-items-center tw-gap-2">
            @if (hasSelected && !isExpanded()) {
                <span class="tw-w-2 tw-h-2 tw-rounded-full tw-bg-[var(--sys-primary)]"></span>
            }
            @if (hasChanges && !isExpanded()) {
                <span data-changes role="img" class="tw-w-2 tw-h-2 tw-rounded-full tw-bg-red-600" [attr.aria-label]="changesLabel ?? null" [attr.title]="changesLabel ?? null"></span>
            }
            <span [class.tw-text-[var(--sys-primary)]]="hasSelected && !isExpanded()"
                class="tw-text-[10px] tw-text tw-font-bold tw-uppercase tw-tracking-widest tw-text-[var(--sys-secondary-text)] tw-opacity-70">
                {{ titleSection }}
            </span>
        </div>

        @if (collapsible) {
            <mat-icon class="tw-text-[16px] tw-transition-transform tw-duration-300 tw-ease-in-out tw-flex tw-items-center tw-justify-center" 
                [class.tw-rotate-180]="!isExpanded()">
                expand_more
            </mat-icon>
        }
    </div>

    @if (isExpanded()) {
        <div class="tw-mt-1">
            <ng-content></ng-content>
        </div>
    }
</div>